import { render, staticRenderFns } from "./InventoryRecord.vue?vue&type=template&id=a81d2750"
import script from "./InventoryRecord.vue?vue&type=script&lang=js"
export * from "./InventoryRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports